@if (isLoading$ | async) {
  <div *ngIf="isLoading$ | async">
    <tools-risk-insights-loading></tools-risk-insights-loading>
  </div>
}

@if (!(isLoading$ | async) && (noData$ | async)) {
  <div class="tw-mt-4">
    <bit-no-items class="tw-text-main">
      <ng-container slot="title">
        <h2 class="tw-font-semibold tw-mt-4">
          {{ "noAppsInOrgTitle" | i18n: organization?.name }}
        </h2>
      </ng-container>
      <ng-container slot="description">
        <div class="tw-flex tw-flex-col tw-mb-2">
          <a class="tw-text-primary-600" routerLink="/login">{{ "learnMore" | i18n }}</a>
        </div>
      </ng-container>
    </bit-no-items>
  </div>
}

@if (!(isLoading$ | async) && !(noData$ | async)) {
  <div class="tw-mt-4 tw-flex tw-flex-col">
    <div class="tw-flex tw-gap-4 tw-col-span-6">
      <dirt-activity-card
        class="tw-col-span-2 tw-cursor-pointer"
        [title]="'atRiskMembers'"
        [value]="atRiskMemberCount"
        [cardMetrics]="'membersAtRisk'"
        [metricDescription]="'membersAtRiskActivityDescription'"
      >
      </dirt-activity-card>
      <dirt-activity-card
        #allAppsOrgAtRiskApplications
        class="tw-col-span-2 tw-cursor-pointer"
        [title]="'criticalApplications'"
        [value]="criticalApplicationsCount"
        [cardMetrics]="'countOfCriticalApplications'"
        [metricDescription]="'criticalApplicationsActivityDescription'"
      >
      </dirt-activity-card>
    </div>
  </div>
}
